import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "rejectionReason", "statusInput", "eventInput" ]

  toggleRejectionReason(event) {
    const status = event.target.value
    const isRejected = status === 'rejected'
    
    this.rejectionReasonTarget.classList.toggle('hidden', !isRejected)

    // Set the AASM event based on the selected status
    const eventMap = {
      'pending': 'reset',
      'pre_approved': 'pre_approve',
      'approved': 'approve',
      'rejected': 'reject'
    }

    // Update the hidden event input if we have a matching event
    const event_name = eventMap[status]
    if (event_name) {
      this.eventInputTarget.value = event_name
      this.statusInputTarget.disabled = true
    } else {
      this.eventInputTarget.value = ''
      this.statusInputTarget.disabled = false
    }

    // Clear rejection reason when not rejecting
    if (!isRejected) {
      const rejectionTextarea = this.rejectionReasonTarget.querySelector('textarea')
      if (rejectionTextarea) {
        rejectionTextarea.value = ''
      }
    }
  }
}
